import {
  type TextareaProps as ChakraTextareaProps,
  Textarea,
} from '@chakra-ui/react';

import type { InputState } from '@burnsred/entity-form';

import { filterProps } from '../../utils/filterProps';

export const TextareaWidget = (props: InputState & ChakraTextareaProps) => {
  return <Textarea className="TextareaWidget" {...filterProps(props)} />;
};
